import {Store, bindActionCreators} from 'redux'
import {setFormFactor} from '../../../../commons/actions/environment'
import {setActiveElement} from '../../../../commons/actions/focus-handler'
import {setPlaceDonationError, setSeatingError} from '../reducers/seating/errors'
import {resetFilters, selectLocation, selectPrice} from '../reducers/seating/filters'
import {
  selectPlace,
  setShowAccessibilityMode,
  setShowMobileBasket,
  setShowPlaceDescription,
  setShowPricingOptionsPlace,
  unselectPlace,
} from '../reducers/seating/mode'
import {updatePlace} from '../reducers/seating/places'
import {Actions} from '../types/actions'
import {addToCalendarClicked, addToCalendarOptionClicked} from './calendar'
import {
  checkout,
  clearCheckout,
  editStep,
  getDiscount,
  handleNextStep,
  nextFormClicked,
  setExpandedTicketIndex,
  setTicketDetails,
  setUseBuyerDetails,
  setValidPaymentAdded,
  submitCheckoutStep,
} from './checkout'
import {applyCoupon, removeCoupon, resetCouponCode} from './coupon'
import {changeEvent, getMembers, shareEvent} from './event'
import {applyGiftCard, removeGiftCard, resetGiftCardCode} from './gift-card'
import {joinGroup} from './groups'
import {clearInvoice} from './invoice'
import {detailsPageLoaded, formPageLoaded, thankYouPageLoaded, ticketedThankYouPageLoaded} from './loaded'
import {ensureLoginForMembersOnly, openMembersModal, promptLogin} from './members'
import {
  closeNativeModal,
  closeUpgradeToPremium,
  openCantCompletePaymentModal,
  openCheckoutUnavailable,
  openConfirmRsvp,
  openHeadlessErrorModal,
  openOccurrencesModal,
  openPolicyDetailsModal,
  openRecurringEventsModal,
  openSeatingPlan,
  openTicketsDetailsModal,
  openTicketsDownloadModal,
  openTimeExpiredModal,
} from './modals'
import {
  navigateBack,
  navigateTo,
  navigateToChangeRsvp,
  navigateToDetails,
  navigateToForm,
  navigateToHomePage,
  navigateToMainPage,
  navigateToOrder,
  navigateToTicketsPicker,
  navigateViaEditor,
  scrollToElement,
} from './navigation'
import {getOccurrences} from './occurrences'
import {downloadTickets} from './order-success'
import {applyPlan, getPlanList, openMembershipPicker} from './paid-plans'
import {paymentMethodSelected, placeOrderButtonClicked} from './payment'
import {
  expressCheckout,
  getCheckoutData,
  getOrderTicketsDownloadUrl,
  pollOrder,
  updateOrder,
  updatePaymentMethod,
} from './placed-order'
import {openPolicyModal, toggleAgreePolicies} from './policies'
import {registrationButtonClicked} from './registration'
import {
  addTicketsToCart,
  cancelReservation,
  clearReservation,
  clearReservationError,
  initiateEcomCheckoutFlow,
  reserveTickets,
} from './reservation'
import {
  changeMemberRsvp,
  changeResponse,
  deleteRsvp,
  editRsvpStep,
  handleNextRsvpStep,
  handleRSVP,
  resetRsvpError,
  submitRsvpStep,
  submitRsvpStepOld,
  updateRsvpStatus,
} from './rsvp'
import {navigateToSchedulePage} from './schedule'
import {seatingMapButtonClick} from './seating/bi'
import {seatingCheckout} from './seating/checkout'
import {
  addPlaceDonation,
  clickPlace,
  resetAreaCounterValue,
  selectPlacePricingOption,
  setAreaCounterValue,
  setPlaceQuantity,
} from './seating/place'
import {changeTicketDonation, selectTicket, setDonationError} from './selected-tickets'
import {getStaticMapUrl} from './static-map'
import {collapseDescription, expandDescription} from './tickets-picker'

export const getExportedActions = (store: Store): Actions => {
  const dispatchActions = {
    navigateToForm,
    navigateToMainPage,
    navigateToHomePage,
    detailsPageLoaded,
    formPageLoaded,
    thankYouPageLoaded,
    ticketedThankYouPageLoaded,
    changeMemberRsvp,
    registrationButtonClicked,
    resetCouponCode,
    resetGiftCardCode,
    removeCoupon,
    removeGiftCard,
    resetRsvpError,
    reserveTickets,
    selectTicket,
    ensureLoginForMembersOnly,
    expandDescription,
    collapseDescription,
    getMembers,
    getPlanList,
    openMembershipPicker,
    promptLogin,
    navigateToTicketsPicker,
    openCheckoutUnavailable,
    updateOrder,
    paymentMethodSelected,
    placeOrderButtonClicked,
    navigateToDetails,
    nextFormClicked,
    openHeadlessErrorModal,
    openPolicyDetailsModal,
    openTicketsDetailsModal,
    openTicketsDownloadModal,
    openOccurrencesModal,
    cancelReservation,
    applyCoupon,
    applyGiftCard,
    addToCalendarClicked,
    addToCalendarOptionClicked,
    applyPlan,
    handleRSVP,
    checkout,
    submitCheckoutStep,
    editStep,
    openTimeExpiredModal,
    openCantCompletePaymentModal,
    setValidPaymentAdded,
    navigateViaEditor,
    setUseBuyerDetails,
    setTicketDetails,
    clearInvoice,
    navigateToOrder,
    navigateToChangeRsvp,
    setExpandedTicketIndex,
    handleNextStep,
    openMembersModal,
    clearCheckout,
    getDiscount,
    downloadTickets,
    shareEvent,
    toggleAgreePolicies,
    openPolicyModal,
    submitRsvpStep,
    submitRsvpStepOld,
    handleNextRsvpStep,
    editRsvpStep,
    changeResponse,
    setFormFactor,
    closeNativeModal,
    navigateToSchedulePage,
    openRecurringEventsModal,
    joinGroup,
    openSeatingPlan,
    openConfirmRsvp,
    setActiveElement,
    setPlaceQuantity,
    updatePlace,
    selectPrice,
    selectLocation,
    setShowAccessibilityMode,
    selectPlace,
    unselectPlace,
    setSeatingError,
    resetFilters,
    seatingMapButtonClick,
    clearReservation,
    clearReservationError,
    initiateEcomCheckoutFlow,
    addTicketsToCart,
    changeTicketDonation,
    setDonationError,
    addPlaceDonation,
    setPlaceDonationError,
    setShowPricingOptionsPlace,
    setShowMobileBasket,
    setShowPlaceDescription,
    clickPlace,
    seatingCheckout,
    selectPlacePricingOption,
    updateRsvpStatus,
    deleteRsvp,
    getOrderTicketsDownloadUrl,
    getStaticMapUrl,
    navigateTo,
    expressCheckout,
    scrollToElement,
    updatePaymentMethod,
    setAreaCounterValue,
    resetAreaCounterValue,
    pollOrder,
    getOccurrences,
    changeEvent,
    closeUpgradeToPremium,
    getCheckoutData,
    navigateBack,
  }

  return {
    ...bindActionCreators(dispatchActions, store.dispatch),
  }
}
